import React, { useContext, useEffect, useMemo, useState } from 'react';
import Heart from "../../../../Assets/Images/HEART.png";
import Soul from "../../../../Assets/Images/SOUL.png";
import Mind from "../../../../Assets/Images/MIND.png";
import Strength from "../../../../Assets/Images/STRENGTH.png";
import HeaderPreview from '../../../GeneratePdf/HeaderPreview';
import FooterPreview from '../../../GeneratePdf/FooterPreview';
import GroupReportContext from '../../../../Context/GroupReportContext';
import { useGroupReportDate } from '../../../../Context/GroupReportDate';

const initialData = [
  { quadrant: 'HEART', no: 1, question: 'When presented with a problem, I am most concerned with how the team is handling it.', score: 1, },
  { quadrant: 'SOUL', no: 1, question: 'My superpower is to rise above any situation to gain a wise perspective.', score: 2, },
  { quadrant: 'MIND', no: 1, question: 'When presented with a problem, I need to understand the processes before I can start.', score: 3, },
  { quadrant: 'STRENGTH', no: 1, question: 'When presented with a problem, I immediately start working on it.', score: 4, },
  { quadrant: 'SOUL', no: 2, question: 'I evaluate decisions by their ability to fulfill the greater vision.', score: 2, },
  { quadrant: 'MIND', no: 2, question: 'I make decisions based on the policies that guide me.', score: 3, },
  { quadrant: 'STRENGTH', no: 2, question: 'I make decisions by focusing on what needs to get done.', score: 4, },
  { quadrant: 'HEART', no: 2, question: 'I ensure my decisions are measured by whether everyone is on board.', score: 1, },
  { quadrant: 'STRENGTH', no: 3, question: 'I feel most fulfilled when I get my tasks completed.', score: 4, },
  { quadrant: 'HEART', no: 3, question: 'I feel most fulfilled when surrounded by my people.', score: 1, },
  { quadrant: 'SOUL', no: 3, question: 'I am most fulfilled when I feel like I am living out my greater purpose.', score: 2, },
  { quadrant: 'MIND', no: 3, question: 'I am most fulfilled when a project works like it was planned.', score: 3, },
  { quadrant: 'MIND', no: 4, question: 'I am motivated when everything has been thoughtfully planned out.', score: 3, },
  { quadrant: 'STRENGTH', no: 4, question: 'I am motivated by winning.', score: 4, },
  { quadrant: 'HEART', no: 4, question: 'I am motivated when I feel a sense of belonging.', score: 1, },
  { quadrant: 'SOUL', no: 4, question: 'I am motivated by opportunities that develop depth of character.', score: 2, },
  { quadrant: 'STRENGTH', no: 5, question: 'I rely heavily on my drive to complete a project.', score: 4, },
  { quadrant: 'SOUL', no: 5, question: 'I rely heavily on the meaning of my story when working on a project.', score: 2, },
  { quadrant: 'MIND', no: 5, question: 'I need clear responsibilities to function well in my work.', score: 3, },
  { quadrant: 'HEART', no: 5, question: 'I rely heavily on passion when working on a project.', score: 1, },
  { quadrant: 'MIND', no: 6, question: 'My superpower is analyzing the solution to a problem.', score: 3, },
  { quadrant: 'HEART', no: 6, question: 'I believe a collaborative team is the best way to achieve results.', score: 1, },
  { quadrant: 'SOUL', no: 6, question: 'I believe our work should connect to a larger purpose.', score: 2, },
  { quadrant: 'STRENGTH', no: 6, question: 'I respect people who deliver results.', score: 4, },
  { quadrant: 'SOUL', no: 7, question: 'I am always searching for the reasons “why” I am doing something.', score: 2, },
  { quadrant: 'STRENGTH', no: 7, question: 'I gain the most satisfaction when I reach my goals.', score: 4, },
  { quadrant: 'HEART', no: 7, question: 'I want to feel connected to others when I am doing something.', score: 1, },
  { quadrant: 'MIND', no: 7, question: 'I find satisfaction in developing standardized procedures.', score: 3, },
  { quadrant: 'HEART', no: 8, question: 'When working on a project, I can become too emotionally invested.', score: 1, },
  { quadrant: 'MIND', no: 8, question: 'When working on a project, I can get stuck by overthinking everything.', score: 3, },
  { quadrant: 'STRENGTH', no: 8, question: 'I can lose momentum without clear, measurable goals.', score: 4, },
  { quadrant: 'SOUL', no: 8, question: 'I struggle to stay engaged when the work has no clear purpose.', score: 2, },
  { quadrant: 'SOUL', no: 9, question: 'I am drawn to people who are visionaries.', score: 2, },
  { quadrant: 'HEART', no: 9, question: 'My strong feelings sometimes overwhelm my good judgment.', score: 1, },
  { quadrant: 'MIND', no: 9, question: 'I believe the right structures are essential for an effective organization.', score: 3, },
  { quadrant: 'STRENGTH', no: 9, question: 'I like turning good ideas into action.', score: 4, },
  { quadrant: 'STRENGTH', no: 10, question: "I take satisfaction in a hard day's work.", score: 4, },
  { quadrant: 'MIND', no: 10, question: 'I find satisfaction in developing effective systems.', score: 3, },
  { quadrant: 'SOUL', no: 10, question: "I find satisfaction in sharing meaningful stories that impact people's lives.", score: 2, },
  { quadrant: 'HEART', no: 10, question: 'When I share a proposal, I want to know "who" is with me.', score: 1, },
];

let sideLabels = [
  {
    "label": "PROBLEM APPROACH",
    "bg": "#394554"
  },
  {
    "label": "DECISION MAKING",
    "bg": "#394554"
  },
  {
    "label": "FULFILLMENT",
    "bg": "#394554"
  },
  {
    "label": "DRIVERS",
    "bg": "#394554"
  },
  {
    "label": "GO-TO'S",
    "bg": "#666666"
  },
  {
    "label": "GUIDING PRINCIPLES",
    "bg": "#394554"
  },
  {
    "label": "MEANING",
    "bg": "#666666"
  },
  {
    "label": "PATTERNS",
    "bg": "#394554"
  },
  {
    "label": "ORIENTATION",
    "bg": "#666666"
  },
  {
    "label": "REWARDS",
    "bg": "#394554"
  }
]



const Logo = (quadrant) => {
  switch (quadrant) {
    case 'HEART': return <img src={Heart} alt="Heart" className="logo" />;
    case 'SOUL': return <img src={Soul} alt="Soul" className="logo" />;
    case 'MIND': return <img src={Mind} alt="Mind" className="logo" />;
    case 'STRENGTH': return <img src={Strength} alt="Strength" className="logo" />;
    default: return null;
  }
};

const QF_ItemTwoPageGroup = ({ apiData, previewData, reportType, pageNumber }) => {
  const [dynamicData] = useState([...initialData]);
  const groupReportCtx = useContext(GroupReportContext);
  const { updateTablevaluesqPage2 } = useGroupReportDate();

  const extractFirstNameFromTeamname = (teamname) => {
    if (!teamname || typeof teamname !== 'string') return '';
    const clean = teamname.trim();
    const m = clean.match(/[A-Za-zÀ-ÖØ-öø-ÿ]+/);
    return (m && m[0]) ? m[0] : clean.split(/\s+/)[0] || '';
  };

  const groupFirstName = useMemo(() => {
    let teamname = previewData?.teamname || apiData?.teamname;

    if (!teamname && typeof window !== 'undefined') {
      try {
        const raw = localStorage.getItem('groupReportPreviewData');
        if (raw) {
          const parsed = JSON.parse(raw);
          const list = Array.isArray(parsed?.data) ? parsed.data : [];
          const id = previewData?.teamId || apiData?.teamId || groupReportCtx?.selectedReport?.teamId;
          const found = id ? list.find(x => String(x.teamId) === String(id)) : undefined;
          teamname = found?.teamname || teamname;
        }
      } catch { /* ignore */ }
    }

    const first = extractFirstNameFromTeamname(teamname);
    return first || 'Participant';
  }, [previewData?.teamname, previewData?.teamId, apiData?.teamname, apiData?.teamId, groupReportCtx?.selectedReport]);

  const displayData = useMemo(() => dynamicData.slice(12, 28), [dynamicData]);


  const allMembersDataArray = Object.values(apiData?.results || {});
  const allVariableSets = allMembersDataArray.map(el => el.variables);
  const allAssessmentDesignation = allMembersDataArray.map(el => el?.designation);
  const allAssessmentHash = allMembersDataArray.map(el => el?.hash);
  const allAssessmentFullName = allMembersDataArray.map(el => el?.fullName);

  const quadrantScores = { HEART: 1, SOUL: 2, MIND: 3, STRENGTH: 4 };

  const allResults = useMemo(() => {
    const results = [];
    displayData.forEach((el) => {
      const res = groupReportCtx?.calculateQuestionScore(
        quadrantScores[el.quadrant],
        allVariableSets,
        el.no,
        "in_focus",
        allAssessmentDesignation,
        allAssessmentHash,
        allAssessmentFullName
      );
      if (res?.averageScore !== null) {
        results.push(parseFloat(res.averageScore) || 0);
      }
    });
    return results;
  }, [displayData, allVariableSets, groupReportCtx?.calculateQuestionScore]);

  useEffect(() => {
    if (allResults?.length) updateTablevaluesqPage2(allResults);
  }, [JSON.stringify(allResults)]);

  const replaceToken = (txt) =>
    typeof txt === 'string' ? txt.replace(/\[First name\]/g, groupFirstName) : txt;

  return (
    <div>
      <HeaderPreview />
      <div className="page">
        {/* <div className="headerBox">
          <h2 className="title">QUADRANT FLOW ITEMS: GROUP OVERVIEW</h2>
          <p className="subTitle">
            This page presents a ranking of items 21-40 distributed across the four quadrants: Heart, Soul, Mind, and Strength. The rankings are based on the combined ratings provided by participants, using a response scale that ranges from 1 (Least) to 4 (Most). Any unselected statement will appear as "-" in the Items Overview chart.
          </p>
        </div> */}

        <div className="content">
          <div className="table">
            <table>
              <thead>
                <tr className="tableHeader">
                  <th className="cellBandHeader"></th>
                  <th className="cellIndex">#</th>
                  <th className="cellQuadrant">Quadrant</th>
                  <th className="cellLogo"></th>
                  <th className="cellQuestion-group">Question</th>
                  <th className="cellScore" style={{padding:"0px 5px"}}>Score</th>
                </tr>
              </thead>
              <tbody>
                {displayData.map((item, index) => {
                  const isCategoryStart = index % 4 === 0;
                  const categoryIndex = Math.floor(index / 4);
                  const category = sideLabels[3 + categoryIndex];
                  const rowClass = `tableRow ${isCategoryStart ? 'categoryStart' : ''}`.trim();
                  const scoreValue = allResults[index];

                  return (
                    <tr key={index} className={rowClass}>
                      {isCategoryStart && (
                        <td
                          className="cellBand categoryBand"
                          rowSpan={4}
                          style={{ backgroundColor: category?.bg }}
                        >
                          <span className="bandLabel">{category?.label}</span>
                        </td>
                      )}
                      <td className="cellIndex">{index + 13}.</td>
                      <td className="cellQuadrant">{item.quadrant}</td>
                      <td className="cellLogo">{Logo(item.quadrant)}</td>
                      <td className="cellQuestion-group">{replaceToken(item.question)}</td>
                      <td className="cellScore">{scoreValue > 0 ? Number(scoreValue).toFixed(1) : "-"}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <FooterPreview pageNumber={pageNumber} reportType={reportType} />
    </div>
  );
};

export default QF_ItemTwoPageGroup;
